import { z } from "zod"

import { entityIdSchema, legalEntityIdSchema } from "./identifiers.js"

export const accountingPeriodReopenPreviewV1Schema = z.object({
  periodId: entityIdSchema,
  legalEntityId: legalEntityIdSchema,
}).strict()

export const accountingPeriodReopenV1Schema =
  accountingPeriodReopenPreviewV1Schema.extend({
    previewFingerprint: z.string().regex(/^[a-f0-9]{64}$/),
    reason: z.string().trim().min(12).max(500),
    stepUpAssertion: z.string().min(100).max(4096),
  }).strict()

export const accountingPeriodReopenResultV1Schema = z.object({
  entityType: z.literal("accounting_period"),
  entityId: entityIdSchema,
  state: z.enum(["reopen_preview", "open"]),
  version: z.number().int().min(1).max(2),
  legalEntityId: legalEntityIdSchema,
  previewFingerprint: z.string().regex(/^[a-f0-9]{64}$/),
  impact: z.object({
    submittedDocuments: z.number().int().nonnegative(),
    lateAdjustments: z.number().int().nonnegative(),
  }).strict(),
  stepUpVerified: z.boolean(),
}).strict()

export type AccountingPeriodReopenV1 = z.infer<
  typeof accountingPeriodReopenV1Schema
>
